import React from 'react'
import BrandLoader from './BrandLoader'

// Kept as the name every table and page already imports; it now shows the
// animated Borku mark instead of the old tail spinner.
const CustomLoader = props => <BrandLoader {...props} />

export default CustomLoader
